module.exports = __webpack_public_path__ + "static-portal/img/007.6f843aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/007.jpg
// module id = ykdK
// module chunks = 4